import { render, staticRenderFns } from "./Receipt-A4.vue?vue&type=template&id=38190887&scoped=true"
import script from "./Receipt-A4.vue?vue&type=script&lang=js"
export * from "./Receipt-A4.vue?vue&type=script&lang=js"
import style0 from "./Receipt-A4.vue?vue&type=style&index=0&id=38190887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38190887",
  null
  
)

export default component.exports